import { useState } from "react";
import styled from "styled-components";
import { CgEye } from "react-icons/cg";
import { MdEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { FaFileDownload } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Grid, IconButton, Tooltip, Typography } from "@mui/material";

import { useAxios } from "../../../hooks";
import pages from "../../../constants/pages";
import { Search } from "../../../components";
import MuiTable from "../../../components/MuiTable";
import { colors } from "../../css components/Style";

const Icon = styled(IconButton)`
  border: 1px solid ${colors.sprintexBlue};
  color: ${colors.sprintexBlue};
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  border-radius: 10px;
  &:hover {
    border: 1px solid ${colors.sprintexBlue};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

export default function List({
  audiences,
  component,
  categorize,
  setPage,
  setSearchKey,
  loading,
}) {
  const navigate = useNavigate();
  var columns = [
    {
      name: "audience_group",
      label: "Audience Group",
    },

    {
      name: "category",
      label: "Category Used",
    },

    {
      name: "action",
      label: "Action",
    },
  ];

  const renderCell = (col, value, row) => {
    if (col.name === "audience_group") {
      return value;
    }

    if (col.name === "category") {
      return <Typography>{value?.slice(0, 5).join(", ")}</Typography>;
    }

    if (col.name === "action") {
      return (
        <div>
          <Tooltip title="View Audience">
            <Icon>
              <CgEye
                onClick={() =>
                  navigate(
                    pages.audienceDetails.route + row.audience_id + "?mode=view"
                  )
                }
                style={{ height: "20px", width: "20px" }}
              />
            </Icon>
          </Tooltip>

          {row.isEditable && (
            <Tooltip title="Edit Audience">
              <Icon
                onClick={() =>
                  navigate(
                    pages.audienceDetails.route + row.audience_id + "?mode=edit"
                  )
                }
              >
                <MdEdit style={{ height: "20px", width: "20px" }} />
              </Icon>
            </Tooltip>
          )}
        </div>
      );
    }

    return value; // default
  };

  return (
    <Grid container spacing={8}>
      <Grid size={12} />
      <Grid size={12}>
        <MuiTable
          loading={loading}
          components={[
            <ToolBar setPage={setPage} setSearchKey={setSearchKey} />,
          ]}
          columns={columns}
          renderCell={renderCell}
          data={audiences}
        />
      </Grid>
    </Grid>
  );
}

export function ToolBar({ setPage, setSearchKey }) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div>
        <Search setPage={setPage} setSearchKey={setSearchKey} />
      </div>
    </div>
  );
}
